module.exports = __webpack_public_path__ + "static/img/xxtb1.bba9bddd.png";